import {createAsyncThunk, createEntityAdapter, createSlice} from '@reduxjs/toolkit';
import {startLoading, stopLoading} from 'app/store/utilSlice';
import {apiDel, apiGet, apiPost, apiPut} from 'app/shared-components/util/restAPI';

const meetingsAdapter = createEntityAdapter({
	sortComparer: (a, b) => b.createdAt - a.createdAt
});

export const fetchMeeting = createAsyncThunk(
  "meetings/fetchMeeting",
  async (id, { dispatch }) => {
	dispatch(startLoading());
	try{
      const apiName = 'CoreAPI3';
	  const path = '/x3/meeting/' + id;
      const options = {
		  headers: {},
		  response: false,
	  };

	  const data = await apiGet(apiName, path, options);
	  return data;
	}finally{
	  dispatch(stopLoading());
	}
  }
);

export const fetchMeetingByEventId = createAsyncThunk(
  "meetings/fetchMeetingByEventId",
  async (eventId, { dispatch }) => {
	dispatch(startLoading());
	try{
      const apiName = 'CoreAPI3';
	  const path = '/x3/meeting/bycalendarevent?eventId=' + eventId;
      const options = {
		  headers: {},
		  response: false,
	  };

	  const data = await apiGet(apiName, path, options);
	  return data;
	}finally{
	  dispatch(stopLoading());
	}
  }
);

export const fetchMeetings = createAsyncThunk(
  "meetings/fetchMeetings",
  async (_, { dispatch, getState }) => {
	dispatch(startLoading());
	try{
		  const {user} = getState();
		  const apiName = 'CoreAPI3';
		  const path = '/x3/meeting/byowner/User:' + user.id;
	      const options = {
			  headers: {},
			  response: false,
		  };
		  const data = await apiGet(apiName, path, options);
	     return data;
	}finally{
	  dispatch(stopLoading());
	}
  }
)

export const createMeeting = createAsyncThunk(
  "meetings/createMeeting",
  async (params, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI3';
		  const path = '/x3/meeting/';
		  let body = { ...params};
	      const options = {
			  headers: {},
			  body: body,
			  response: false,
		  };

		 let meeting = await apiPut(apiName, path, options);
		 return meeting;
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

export const updateMeeting = createAsyncThunk(
  "meetings/updateMeeting",
  async (params, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI3';
		  const path = '/x3/meeting/' + params.id;
		  let body = { 
			  ...params,
			  id: undefined,
		  };
	      const options = {
			  headers: {},
			  body: body,
			  response: false,
		  };

		 let data = await apiPut(apiName, path, options);
		 return data;
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

export const deleteMeeting = createAsyncThunk(
  "meetings/deleteMeeting",
  async ({id}, { dispatch }) => {
	  dispatch(startLoading());
	  try{
	      const apiName = 'CoreAPI3';
		  const path = '/x3/meeting/' + id;
	      const options = {
			  headers: {},
			  response: false,
		  };

		 let data = await apiDel(apiName, path, options);
		 return { id, data };
	 }finally{
		 dispatch(stopLoading());
	 }
  }
)

const meetingsSlice = createSlice({
  name: "meetings",
  initialState: meetingsAdapter.getInitialState({
	  selectedMeetingId: null,
  }),
  reducers: {
    setSelectedMeetingId: (state, action) => {
      state.selectedMeetingId = action.payload;
    },
  },
  extraReducers: builder => {
    builder
    .addCase(fetchMeeting.fulfilled, (state, action) => {
		meetingsAdapter.setOne(state, action.payload);
    })
    .addCase(fetchMeetingByEventId.fulfilled, (state, action) => {
		if (action.payload) meetingsAdapter.setOne(state, action.payload);
    })
    .addCase(fetchMeetings.fulfilled, (state, action) => {
        meetingsAdapter.setMany(state, action.payload);
    })
    .addCase(createMeeting.fulfilled, (state, action) => {
        meetingsAdapter.addOne(state, action.payload);
    })
    .addCase(updateMeeting.fulfilled, (state, action) => {
		meetingsAdapter.upsertOne(state, action.payload);
    })
    .addCase(deleteMeeting.fulfilled, (state, action) => {
      	const id = action.payload.id;
     	meetingsAdapter.removeOne(state, id);
    })
  }
})

const { selectById, selectAll } = meetingsAdapter.getSelectors();

export const selectMeetingById = (id) => state => {
	return selectById(state.meetings, id);
}

export const selectMeetingByIdOrEventId = (meetingId, eventId) => state => {
	const meetings = selectAll(state.meetings);
	return meetings.find(m => 
		m?.id === meetingId || 
		m?.managedCalendarEventId === eventId
	);
}

export const selectAllMeetings = () => state => {
	return selectAll(state.meetings);
}

export const selectSelectedMeetingId = () => state => {
	return state.meetings.selectedMeetingId;
}

export const { setSelectedMeetingId } = meetingsSlice.actions;

export default meetingsSlice.reducer;